// extracted by mini-css-extract-plugin
export default {"glitchWrapper":"glitchWrapper-11oZpB","glitch":"glitch-Hf_ALO","glitch-anim-2":"glitch-anim-2-fKr1xo","glitch-anim":"glitch-anim-18ftDA"};